import {Component, OnInit} from '@angular/core';
import {UserService} from '../../services/user.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from '../../validator/custom-validators';
import {HttpErrorResponse} from '@angular/common/http';
import {MenuItem} from '../../interfaces/menu-item';
import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js';
import {ISignUpResult} from 'amazon-cognito-identity-js';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-user',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserListComponent implements OnInit {
  userDataDetails: any = [];
  selectedUser: any = [];
  public showCreateForm: Boolean = false;
  public isError = false;
  public isSuccess = false;
  public errorMsg = '';
  public successMsg = '';
  itemForm: FormGroup;
  submitType = 'Save';

  constructor(private uservice: UserService, private fb: FormBuilder) {
    this.createForm();
  }

  ngOnInit() {
    this.getUserDetails();
  }

  onSubmit() {
    this.selectedUser = this.prepareSave();
    console.log(this.selectedUser);
    const poolData = {
      UserPoolId: environment.cognito.userPoolId,
      ClientId: environment.cognito.clientId // Your client id here
    };
    const poolRegion = 'ap-south-1';
    const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

    const attributeList = [];
    attributeList.push(new AmazonCognitoIdentity.CognitoUserAttribute({Name: 'name', Value: this.selectedUser.name}));
    attributeList.push(new AmazonCognitoIdentity.CognitoUserAttribute({Name: 'family_name', Value: this.selectedUser.family_name}));
    attributeList.push(new AmazonCognitoIdentity.CognitoUserAttribute({Name: 'email', Value: this.selectedUser.email}));

    userPool.signUp(this.selectedUser.email, this.selectedUser.pass, attributeList, null, (err: Error, result: ISignUpResult) => {
      if (err) {
        console.log(err);
        this.isError = true;
        this.errorMsg = err.message;
        this.isSuccess = false;
        this.successMsg = '';
        return;
      }
      this.showCreateForm = false;
      const cognitoUser = result.user;
      console.log(cognitoUser);
      console.log('user name is ' + cognitoUser.getUsername());
      this.isSuccess = true;
      this.isError = false;
      this.errorMsg = '';
      this.successMsg = cognitoUser.getUsername() + ' added Successfully!';
      this.rebuildForm();
      this.getUserDetails();
    });
  }

  rebuildForm() {
    this.itemForm.reset({
      id: this.selectedUser.id,
      name: this.selectedUser.name,
      family_name: this.selectedUser.family_name,
      email: this.selectedUser.email,
      pass: this.selectedUser.pass
    });
  }

  prepareSave() {
    const formModel = this.itemForm.value;

    const UserDatas = {
      id: formModel.id,
      name: formModel.name,
      family_name: formModel.family_name,
      email: formModel.email,
      pass: formModel.pass
    };
    return UserDatas;
  }

  createForm() {
    this.itemForm = this.fb.group({
      id: 0,
      name: ['', Validators.required],
      family_name: ['', Validators.required],
      email: ['', [Validators.required]],
      pass: ['', [Validators.required]]
    });
  }

  createUser() {
    this.showCreateForm = true;
  }

  cancelForm() {
    this.isSuccess = false;
    this.isError = false;
    this.rebuildForm();
    this.showCreateForm = false;
  }

  deactivate(type, user) {
    console.log(user);
  }

  getUserDetails() {
    this.uservice.getUserList().subscribe((data) => {
      this.userDataDetails = data;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/user/user-list.component.ts